import React from 'react'
import { Avatar } from '@chakra-ui/react'
import { Box, Text } from '@chakra-ui/react'
import { getUserFullName } from '~utils/helpers'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { useTeamChatMessageProperties } from './properties-provider'
import { formatHumanReadableDate } from '~components/chats/chat/messages-list/message-content/message-helpers'
import TeamChatMessageAttachments from './attachments'
import { Flex } from '@chakra-ui/react'
import { format } from 'date-fns'
import MentionText from '~components/shared/text/mention-text'

export default function TeamChatMessageItem() {
    const { message, isPastSmThreshold, isFirst } =
        useTeamChatMessageProperties()
    const { text, sender, created_at, internal_chat_messages_attachments } =
        message

    const showUserInfo = isPastSmThreshold || isFirst

    return (
        <Box px={6} py={2} role="group" _hover={{ bg: 'gray.50' }}>
            <SharedStack row align="flex-start" spacing={3}>
                {showUserInfo ? (
                    <Avatar
                        src={sender.user.avatar_url || ''}
                        name={getUserFullName(sender.user)}
                        borderRadius="lg"
                        size="sm"
                        mt={1}
                        w={9}
                        h={9}
                    />
                ) : (
                    <Flex w={9} flexDir="row" justify="flex-end" align="center">
                        <Text
                            fontSize="11px"
                            lineHeight="21px"
                            color="gray.600"
                            opacity={0}
                            _groupHover={{ opacity: 1 }}
                        >
                            {format(created_at, 'h:mm')}
                        </Text>
                    </Flex>
                )}
                <Box>
                    {showUserInfo && (
                        <SharedStack row fit spacing={2}>
                            <Text fontSize="sm" fontWeight="semibold">
                                {getUserFullName(sender.user)}
                            </Text>
                            <Text fontSize="xs" color="gray.500">
                                {format(created_at, 'h:mm a')}
                            </Text>
                        </SharedStack>
                    )}
                    <Text
                        fontSize="sm"
                        sx={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }}
                    >
                        <MentionText text={text} />
                    </Text>
                    <TeamChatMessageAttachments
                        attachments={internal_chat_messages_attachments}
                    />
                </Box>
            </SharedStack>
        </Box>
    )
}
